import BaseCard from './BaseCard';
import { CardType } from './CardType';

export default class ValueCard extends BaseCard {
    public onCreate(params: any): void {
        params.cardFrontTexture = `card${params.value + 1}`;
        params.type = CardType.value;
        super.onCreate(params);
    }
}
